import { motion } from "framer-motion";

const HERO_BG = "https://static.prod-images.emergentagent.com/jobs/7a9b6db3-da51-486d-b381-a72900b8fc1d/images/c371a76cb25fe848c920302f5418d709b49227e19714e164af48f76fb7e33779.png";

const fadeIn = (delay = 0) => ({
    initial: { opacity: 0, y: 20 },
    whileInView: { opacity: 1, y: 0 },
    viewport: { once: true, margin: "-80px" },
    transition: { duration: 0.8, delay, ease: [0.16, 1, 0.3, 1] },
});

export const FinalCta = ({ onBegin }) => {
    return (
        <section
            id="get-started"
            data-testid="landing-final-cta"
            className="relative py-20 lg:py-28 overflow-hidden"
        >
            <div className="absolute inset-0 -z-10">
                <img src={HERO_BG} alt="" className="w-full h-full object-cover opacity-10" />
                <div className="absolute inset-0 bg-gradient-to-b from-white/90 via-white/95 to-white" />
                <div className="pointer-events-none absolute -top-32 left-1/2 -translate-x-1/2 w-[600px] h-[600px] rounded-full opacity-40 blur-[100px]"
                    style={{ background: "radial-gradient(circle, rgba(255,90,0,0.5), rgba(255,90,0,0) 65%)" }} />
            </div>

            <div className="mx-auto max-w-5xl px-6 lg:px-10 text-center">
                <motion.div {...fadeIn(0)} className="font-mono-tech text-[11px] uppercase tracking-[0.35em] text-[#FF5A00] mb-6">
                    <span className="inline-block w-6 h-px bg-[#FF5A00] align-middle mr-3" />
                    09 / Your next move
                </motion.div>

                <motion.h2
                    {...fadeIn(0.1)}
                    className="font-display font-black tracking-tighter text-white text-4xl sm:text-5xl lg:text-7xl leading-[0.95]"
                >
                    Be the name they see<br />
                    <span className="text-[#FF5A00] text-glow-orange">on the way home</span>.
                </motion.h2>

                <motion.p
                    {...fadeIn(0.2)}
                    className="mt-8 max-w-2xl mx-auto text-base sm:text-lg text-slate-300 leading-relaxed"
                >
                    Digital billboards put your brand on the routes your customers
                    already travel. Pick your screens, lock your dates, upload your
                    artwork — real prices, no lock-ins, real people on your account.
                </motion.p>

                <motion.div {...fadeIn(0.32)} className="mt-12 flex flex-col sm:flex-row items-center justify-center gap-4">
                    <button
                        onClick={onBegin}
                        data-testid="landing-final-cta-primary"
                        className="group relative inline-flex items-center gap-3 bg-[#FF5A00] hover:bg-[#E65200] text-white px-10 py-5 text-sm font-semibold uppercase tracking-widest transition-all duration-300 border-glow-orange"
                    >
                        Put Me On A Billboard
                        <span className="inline-block transition-transform group-hover:translate-x-1">→</span>
                    </button>
                    <a
                        href="/map"
                        data-testid="landing-final-cta-map"
                        className="inline-flex items-center gap-2 px-10 py-5 text-sm font-semibold uppercase tracking-widest text-white border border-white/15 hover:border-white/40 hover:bg-white/5 transition-all"
                    >
                        Or open the live map
                    </a>
                </motion.div>

                <motion.p {...fadeIn(0.42)} className="mt-10 text-xs text-slate-500 font-mono-tech uppercase tracking-widest">
                    No account needed to explore · Only pay after choosing screens &amp; dates
                </motion.p>
            </div>
        </section>
    );
};
